import { render, staticRenderFns } from "./AccountManagementV2.vue?vue&type=template&id=80aaf646&scoped=true"
import script from "./AccountManagementV2.vue?vue&type=script&lang=js"
export * from "./AccountManagementV2.vue?vue&type=script&lang=js"
import style0 from "./AccountManagementV2.vue?vue&type=style&index=0&id=80aaf646&prod&lang=css"
import style1 from "./AccountManagementV2.vue?vue&type=style&index=1&id=80aaf646&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80aaf646",
  null
  
)

export default component.exports